// third-party
import { combineReducers } from "redux";

// project imports
import snackbarReducer from "./slices/snackbar";
import customerReducer from "./slices/customer";
import siteReducer from "./slices/site";
import userReducer from "./slices/user";
import robotReducer from "./slices/robot";
import deviceReducer from "./slices/device";
import chargerReducer from "./slices/charger";
import menuReducer from "./slices/menu";
import kioskReducer from "./slices/kiosk";
import toolReducer from "./slices/tool";
import helpReducer from "./slices/help";
import analyticsReducer from "./slices/analytics";
import sitesMap from "./slices/sitesMap";
import groupReducer from "./slices/group";
import utilsReducer from "./slices/utils";
import containerReducer from "./slices/container";
import locusDashboardsReducer from "./slices/locusDashboards";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  customer: customerReducer,
  site: siteReducer,
  user: userReducer,
  menu: menuReducer,
  kiosk: kioskReducer,
  robot: robotReducer,
  device: deviceReducer,
  charger: chargerReducer,
  tool: toolReducer,
  help: helpReducer,
  analytics: analyticsReducer,
  sitesMap: sitesMap,
  group: groupReducer,
  utils: utilsReducer,
  container: containerReducer,
  locusDashboards: locusDashboardsReducer,
});

export default reducer;
